<template>
	<div
		class="g-block-pay-jumplink-bar"
		:class="{
			'g-block-pay-jumplink-bar--edit': editable,
			'is-active': editable && active,
			'g-block-pay-jumplink-bar--h5': h5,
		}"
		@click="onWrapClick"
	>
		<div
			class="g-block-pay-jumplink-bar__card"
			:style="cardStyle"
			@click.stop="onButtonClick"
		>
			<span class="g-block-pay-jumplink-bar__promo" :style="{ color: btnColor }">
				{{ data.promoTag || '限时优惠' }}
			</span>
			<span v-if="!isGeditModulePaid && !shouldHidePrice" class="g-block-pay-jumplink-bar__price">
				<span class="g-block-pay-jumplink-bar__currency">¥</span>
				<span class="g-block-pay-jumplink-bar__integer">{{ priceParts.integer }}</span>
				<span class="g-block-pay-jumplink-bar__decimal">{{ priceParts.decimal }}</span>
			</span>
			<span class="g-block-pay-jumplink-bar__divider"></span>
			<div class="g-block-pay-jumplink-bar__action">
				<i class="mbm-iconfont mbm-iconfontanquan"></i>
				<span class="g-block-pay-jumplink-bar__title">{{ (isGeditModulePaid ? data.unlockedTitle : '') || data.title || '解锁完整内容' }}</span>
			</div>
			<span class="g-block-pay-jumplink-bar__arrow">
				<i class="mbm-iconfont mbm-youjiantou1" :style="{ color: btnColor }"></i>
			</span>
		</div>
	</div>
</template>

<script>
	import { payUnlockMixin } from '../shared/mixin.js';
	import { formatPayPrice, getButtonColor, getButtonStyle } from '../shared/utils.js';
	import { navigateJumpLink } from '../../../utils/jumpLink.js';
	import { DEFAULT_PAY_UNLOCK_JUMPLINK_BAR } from '../../../templates.js';

	export default {
		name: 'GBlockPayUnlockJumpLinkBar',
		mixins: [payUnlockMixin],
		computed: {
			btnColor() {
				return getButtonColor(this.data, DEFAULT_PAY_UNLOCK_JUMPLINK_BAR);
			},
			cardStyle() {
				return {
					...getButtonStyle(this.data, DEFAULT_PAY_UNLOCK_JUMPLINK_BAR),
					color: '#fff',
				};
			},
			priceParts() {
				const price = formatPayPrice(this.data.price ?? DEFAULT_PAY_UNLOCK_JUMPLINK_BAR.price);
				const [integer, decimal = '00'] = price.split('.');
				return {
					integer,
					decimal: `.${decimal}`,
				};
			},
		},
		methods: {
			onButtonClick(e) {
				if (this.editable) {
					e?.stopPropagation?.();
					this.$emit('select');
					return;
				}
				if (this.isGeditModulePaid) {
					this.doJump();
				} else {
					this.runModulePayFlow();
				}
			},
			doJump() {
				if (this.data.jumpLink?.type) {
					navigateJumpLink(this.data.jumpLink, {
						apiRequest: this.$apiRequest,
					});
					return;
				}
				const jumpUrl = this.data.jumpUrl;
				if (!jumpUrl) {
					console.warn('JumpLinkBar: 未配置跳转链接');
					return;
				}
				window.location.href = jumpUrl;
			},
			runModulePayFlow() {
				if (this.editable) return;
				if (!this.isGeditRealPay) return;
				if (this.isGeditModulePaid) return;
				const oId = this.geditPayModuleId;
				if (!oId) return;
				const requestPay = this.geditPay?.requestPay;
				if (typeof requestPay !== 'function') return;
				Promise.resolve(requestPay(oId)).catch(() => {});
			},
		},
	};
</script>

<style scoped lang="less">
	.g-block-pay-jumplink-bar {
		&--edit {
			border: 1px solid transparent;
			border-radius: 999px;
			transition: border-color 0.2s, box-shadow 0.2s;
			cursor: pointer;

			&.is-active {
				border-color: #285af9;
				box-shadow: 0 0 0 1px rgba(40, 90, 249, 0.15);
			}
		}
	}

	.g-block-pay-jumplink-bar__card {
		display: flex;
		align-items: center;
		gap: 10px;
		min-height: 56px;
		padding: 8px 12px 8px 14px;
		border-radius: 10px;
		box-shadow: 0 2px 12px rgba(0, 0, 0, 0.2);
		cursor: pointer;
		user-select: none;
	}

	.g-block-pay-jumplink-bar__promo {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		padding: 4px 8px;
		border-radius: 6px;
		background: #fff;
		font-size: 12px;
		font-weight: 600;
		line-height: 1.2;
	}

	.g-block-pay-jumplink-bar__price {
		flex-shrink: 0;
		display: inline-flex;
		align-items: flex-end;
		font-weight: 700;
		line-height: 1;
		color: #fff;
	}

	.g-block-pay-jumplink-bar__currency {
		font-size: 14px;
		margin-right: 1px;
		margin-top: 8px;
	}

	.g-block-pay-jumplink-bar__integer {
		font-size: 28px;
		letter-spacing: -0.5px;
	}

	.g-block-pay-jumplink-bar__decimal {
		font-size: 14px;
		margin-top: 4px;
	}

	.g-block-pay-jumplink-bar__divider {
		flex-shrink: 0;
		width: 1px;
		height: 28px;
		background: rgba(255, 255, 255, 0.45);
		margin: 0 2px;
	}

	.g-block-pay-jumplink-bar__action {
		display: flex;
		align-items: center;
		gap: 6px;
		min-width: 0;
		flex: 1;
		justify-content: flex-end;
		.mbm-iconfont {
			flex-shrink: 0;
			font-size: 18px;
			color: #fff;
		}
	}

	.g-block-pay-jumplink-bar__title {
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		font-size: 16px;
		font-weight: 700;
		line-height: 1.2;
		color: #fff;
	}

	.g-block-pay-jumplink-bar__arrow {
		flex-shrink: 0;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		width: 28px;
		height: 28px;
		border-radius: 50%;
		background: #fff;

		.mbm-iconfont {
			font-size: 18px;
			font-weight: 700;
		}
	}

	.g-block-pay-jumplink-bar--h5 {
		.g-block-pay-jumplink-bar__card {
			border-radius: 0.2rem;
			gap: 0.2rem;
			min-height: 1.12rem;
			padding: 0.16rem 0.24rem 0.16rem 0.28rem;
			box-shadow: 0 0.04rem 0.24rem rgba(0, 0, 0, 0.2);
		}

		.g-block-pay-jumplink-bar__promo {
			padding: 0.08rem 0.16rem;
			border-radius: 0.12rem;
			font-size: 0.24rem;
		}

		.g-block-pay-jumplink-bar__currency {
			font-size: 0.28rem;
			margin-top: 0.16rem;
		}

		.g-block-pay-jumplink-bar__integer {
			font-size: 0.56rem;
		}

		.g-block-pay-jumplink-bar__decimal {
			font-size: 0.28rem;
			margin-top: 0.08rem;
		}

		.g-block-pay-jumplink-bar__divider {
			height: 0.56rem;
			margin: 0 0.04rem;
		}

		.g-block-pay-jumplink-bar__action {
			gap: 0.12rem;

			.mbm-iconfont {
				font-size: 0.36rem;
			}
		}

		.g-block-pay-jumplink-bar__title {
			font-size: 0.32rem;
		}

		.g-block-pay-jumplink-bar__arrow {
			width: 0.56rem;
			height: 0.56rem;

			.mbm-iconfont {
				font-size: 0.35rem;
			}
		}
	}
</style>
